import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_SGTEC_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterAnexos(projetoId) {
        return axiosJwt
            .get(`${api}/sgtec/uabs/projetos/${projetoId}/anexos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexosTipos(projetoId) {
        return axiosJwt
            .get(
                `${api}/sgtec/uabs/projetos/${projetoId}/anexos/tipos`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirAnexo(anexo) {
        const formData = new FormData()
        formData.append('codProjeto', anexo.codProjeto)
        formData.append('projetoId', anexo.projetoId)
        formData.append('tipoId', anexo.tipoId)
        formData.append('descritivo', anexo.descritivo)
        formData.append('arquivo', anexo.arquivo)

        return axiosJwt
            .post(
                `${api}/sgtec/uabs/projetos/${anexo.projetoId}/anexos`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirAnexo(projetoId, anexoId) {
        return axiosJwt
            .delete(
                `${api}/sgtec/uabs/projetos/${projetoId}/anexos/${anexoId}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexo(projetoId, anexoId) {
        return axiosJwt
            .get(
                `${api}/sgtec/uabs/projetos/${projetoId}/anexos/${anexoId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
